import Enum from "./Enum";

export default Enum.create( {
	UPLOAD: "UPLOAD",
	BOT: "BOT",
} );
